import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-edition",
  "use": "gw-edition-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"gw-edition\"><path d=\"M18 0h-8C8.9 0 8 .9 8 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm0 8h-8V4h8v4ZM5 5c-.55 0-1 .45-1 1v6c0 1.1.9 2 2 2h8c.55 0 1-.45 1-1s-.45-1-1-1H6V6c0-.55-.45-1-1-1Zm-5 5c0-.55.45-1 1-1s1 .45 1 1v6h8c.55 0 1 .45 1 1s-.45 1-1 1H2c-1.1 0-2-.9-2-2v-6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol